export function Header() {
  return (
    <header>
      <div className="header-vitals">
              <i className="icon icon_enlinea_signos_vitales_header"></i>SIGMA <strong>VITAL</strong>
      </div>
    </header>
  )
}